'use strict';

const React = require( 'react' );
const classNames = require( 'classnames' );
const propTypes = require('prop-types');
const DateHelper = require( '../../../../../_plugins/lib/dateHelper' );
const { string, bool } = propTypes;
const createReactClass = require('create-react-class');

const TimeSelect = createReactClass({
  propTypes: {
    activeTime: string,
    name: string,
    fullWidth: bool,
    homePageSplitTest: bool
  },

  getDefaultProps() {
    return {
      activeTime: '1200',
      fullWidth: false,
      homePageSplitTest: false
    };
  },

  makeOptions() {
    const arr = Array.apply( null, { length: 48 }).map( Number.call, Number );
    return arr.filter( i => {
      return i;
    }).map( i => {
      let val = parseInt( i / 2, 10 );
      let padVal = DateHelper.pad( val * 100, 4 );
      if ( ( i + 1 ) % 2 === 0 ) padVal = DateHelper.pad( ( val * 100 ) + 30, 4 );
      const returnText = padVal.slice( 0, 2 ) + ':' + padVal.slice( -2 );
      return ( <option key={i} value={padVal}>{returnText}</option> );
    });
  },

  render() {
    const { activeTime, name, fullWidth, homePageSplitTest } = this.props;
    /* TECH Debt for am/pm splittest */
    const times = this.makeOptions();
    const timeClass = classNames({
      'time': true,
      'col-xs-3': homePageSplitTest,
      'col-xs-4': !fullWidth && !homePageSplitTest,
      'pull-right': !fullWidth,
      'col-xs-7': fullWidth && !homePageSplitTest
    });
    return (
      <select name={name} data-track-name={name} className={ timeClass } defaultValue={activeTime}>{times}</select>
    );
  }
});

module.exports = TimeSelect;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/times-dropdown.jsx